// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"43":"ac72a5eb0374d56b99c274edcc997d6bffbbe413","157":"component---src-pages-casino-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"43":"dcb8fe41c7888ac2d40a","157":"04a4f7b76d338efe5c6e","218":"01e601f7a8371b76d559","691":"f4d318e8b6126656cdbe"}[chunkId] + ".js";
};